import React, { PureComponent, useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { lineChart } from "../Utils/demoAnalysis";
import { X_factor_getColor } from "../Utils/functions";
import { useNavigate } from "react-router-dom";

const CustomizedDot = (props) => {
  const { cx, cy, stroke, payload, value } = props;
  const navigate = useNavigate();

  return (
    <circle
      cx={cx}
      cy={cy}
      r={10}
      fill={X_factor_getColor(value)}
      style={{ cursor: "pointer" }}
      onClick={() => navigate("/game/most-recent-game#game-stats")}
    />
  );
};

const PlayerLineChart = ({ chartType, player_score }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const data = lineChart(chartType, player_score);
    setChartData(data);
  }, [chartType, player_score]);

  const formatYAxis = (score) => {
    // Return empty string for the bottom tick (50)
    // if (score === 50) return "";

    if (score >= 95 && score <= 100) return "NBA";
    if (score >= 87 && score <= 94) return "High Major";
    if (score >= 77 && score <= 86) return "DI";
    if (score >= 66 && score <= 76) return "DII/III";
    if (score >= 55 && score <= 65) return "Juco";
    if (score >= 0 && score <= 55) return "HS";
  };

  return (
    <div className="analysis-line-chart">
      <div style={{ height: "300px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={300}
            data={chartData}
            margin={{
              top: 15,
              right: 10,
              left: 5,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis
              tickFormatter={formatYAxis}
              width={70}
              domain={[50, 100]}
              ticks={[50, 65, 76, 86, 94, 100]}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="date"
              stroke="#8884d8"
              dot={<CustomizedDot />}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PlayerLineChart;
